var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStockPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2001 3.2002C2.53147 3.2002 2.8001 3.46882 2.8001 3.8002V15.2666H17.2752C17.6065 15.2666 17.8752 15.5352 17.8752 15.8666C17.8752 16.198 17.6065 16.4666 17.2752 16.4666H2.2001C1.86873 16.4666 1.6001 16.198 1.6001 15.8666V3.8002C1.6001 3.46882 1.86873 3.2002 2.2001 3.2002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1811 3.54944C17.5084 3.4977 17.8157 3.7211 17.8674 4.04841L18.7104 9.38219C18.7622 9.7095 18.5388 10.0168 18.2115 10.0685C17.8842 10.1202 17.5769 9.89685 17.5252 9.56954L16.9083 5.66652L12.6455 11.5297C12.5332 11.6842 12.354 11.776 12.163 11.7769C11.9719 11.7778 11.7919 11.6876 11.6782 11.5341L9.14157 8.11136L5.30014 13.2299C5.10123 13.495 4.72513 13.5486 4.4601 13.3497C4.19506 13.1508 4.14146 12.7747 4.34036 12.5096L8.66472 6.74759C8.77842 6.59608 8.95699 6.50717 9.14642 6.50774C9.33584 6.50831 9.51387 6.5983 9.62666 6.75049L12.1556 10.1629L15.9377 4.96087L12.0346 5.57776C11.7073 5.6295 11.4001 5.4061 11.3483 5.07879C11.2966 4.75149 11.52 4.44421 11.8473 4.39248L17.1811 3.54944Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStockPrice);
export default __webpack_public_path__ + "static/media/icon_stock_price.e1ded8e083deb4b098e1dc06f37aed6b.svg";
export { ForwardRef as ReactComponent };